import { Transition } from '@unseenco/taxi';

export default class FadeTransition extends Transition {
  onLeave({ from, done }) {
    from.style.transition = 'opacity 0.4s ease';
    from.style.opacity = '0';

    setTimeout(done, 400);
  }

  onEnter({ to, done }) {
    // Ensure new content starts hidden
    to.style.opacity = '0';
    to.style.transition = 'opacity 0.4s ease';

    // Delay to allow browser to apply styles
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        to.style.opacity = '1';
      });
    });

    setTimeout(done, 400);
  }
}